import React from 'react'
import {Box, Button, Flex, Stack, Text} from '../../vanilla'
import {CheckCircleIcon} from '../../components/icons'
import {Link} from 'react-router-dom'
import {MealDealContinueBox} from './meal-deal-continue-box'

export const MealDealCompletePrompt: React.FC<{resetBuilder: () => void}> = ({resetBuilder}) => {
  return (
    <>
      <Box
        alignItems="center"
        justifyContent="center"
        display="flex"
        flexDirection="column"
        gap="16px"
        padding="24px"
        maxWidth="450px"
        width="full"
        alignSelf="center"
      >
        <Flex
          flexDirection="row"
          background="lightGreen"
          border="1px"
          borderColor="green"
          padding="16px"
          gap="8px"
          minWidth="full"
          borderRadius="slight"
        >
          <Stack>
            <CheckCircleIcon color="green" boxSize="32px" />
          </Stack>
          <Stack>
            <Text variant="heading1" data-test-selector="basket-deal-text">
              Deal in Basket
            </Text>
            <Text variant="text2" data-test-selector="basket-confirmation-message">
              Your deal has been added to your basket
            </Text>
            <Text
              variant="text2"
              color="accent6"
              textDecoration="underline"
              data-test-selector="view-basket-button"
            >
              <Link to="/basket">View Basket</Link>
            </Text>
          </Stack>
        </Flex>
        <Stack></Stack>
        <Button
          variant="dark"
          onClick={() => resetBuilder()}
          width="full"
          data-test-selector="create-another-deal-button"
        >
          Create Another Deal
        </Button>
        <MealDealContinueBox />
      </Box>
    </>
  )
}
